import { useMemo } from 'react';
import { useHttpClient } from '@wix/cli-http-client-react';
import { usePanoramaMethodLogger } from '@wix/cli-panorama';
import { FunnelProjectsClient } from './funnel-projects-client.js';

export function useFunnelProjectsClient(): FunnelProjectsClient {
  const httpClient = useHttpClient({ type: 'api' });
  const client = useMemo(
    () => new FunnelProjectsClient(httpClient),
    [httpClient]
  );

  return usePanoramaMethodLogger(client);
}
